import Image from "next/image";

import type { ContentImage } from "../../_types/content";

interface StorefrontMediaProps {
  image: ContentImage;
  sizes: string;
  priority?: boolean;
  className?: string;
}

export default function StorefrontMedia({
  image,
  sizes,
  priority = false,
  className = "",
}: StorefrontMediaProps) {
  if (image.src.startsWith("MOCK_IMAGE_")) {
    return (
      <div
        role="img"
        aria-label={image.alt}
        className={`flex aspect-square h-full w-full items-center justify-center bg-clay p-6 text-center text-sand ${className}`}
      >
        <span className="max-w-[20rem] font-neueheitz text-lg leading-snug break-words">
          {image.src}
        </span>
      </div>
    );
  }

  return (
    <div className={`relative aspect-square w-full ${className}`}>
      <Image
        src={image.src}
        alt={image.alt}
        fill
        priority={priority}
        sizes={sizes}
        className="object-cover"
      />
    </div>
  );
}
